import clsx from 'clsx'

import { Tag } from '@/components/Tag'
import { Warning } from '@/components/Warning'

import { useEntry } from '../BlogPost.hooks'

type Props = {
	className?: string
}

export function BlogPostCategories({ className }: Props) {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={className}>{entry.error}</Warning>
	}

	return (
		<div className={clsx('flex flex-wrap gap-3', className)}>
			{entry.data.categoriesCollection?.items.map(
				(category) =>
					category && (
						<Tag key={category.sys.id} link={{ href: `/blog/category/${category.slug}` }}>
							{category.name}
						</Tag>
					)
			)}
		</div>
	)
}
